import React from "react";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Typography } from "@mui/material";


const Search = styled("div")(({ theme }) => ({
  position: "relative",
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  maxWidth: "180px",
  height: "30px",
  display: "flex",
  alignItems: "center",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 1),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  boxSizing: "border-box",
  paddingRight: "32px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(0.3)})`,
  },
  height: "30px",
}));

export const CommonSearch = ({ style, label, value, handleChange, disabled, minChars = 1 }) => {
  const [error, setError] = React.useState(false);
  const [localValue, setLocalValue] = React.useState(value || "");
  const lastPropagatedValueRef = React.useRef(value || "");

  const onLocalChange = (e) => {
    const val = e.target.value;
    setLocalValue(val);
    
    const isError = val.length > 0 && val.length < minChars;
    setError(isError);

    // Only update parent search if length is 0 (to clear) or >= minChars (to search)
    if (val.length === 0 || val.length >= minChars) {
      lastPropagatedValueRef.current = val;
      if (handleChange) {
        handleChange(e);
      }
    }
  };

  // Sync with parent value if it changes externally
  React.useEffect(() => {
    if (value !== undefined && value !== lastPropagatedValueRef.current) {
      setLocalValue(value || "");
      lastPropagatedValueRef.current = value || "";
    }
  }, [value]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', position: 'relative', width: "100%", alignItems: style?.alignItems || "flex-start" }}>
      <Search
        style={{
          borderRadius: 4,
          borderColor: error ? "#d32f2f" : "#bdbdbd",
          borderWidth: 1,
          borderStyle: "solid",
          width: "100%",
          maxWidth: "250px",
          backgroundColor: "white",
          ...style,
        }}
      >
        <StyledInputBase
          placeholder={label || "Search…"}
          inputProps={{ "aria-label": "search" }}
          name="searchValue"
          value={localValue}
          onChange={onLocalChange}
          autoComplete="off"
          disabled={disabled}
          sx={{ width: "100%" }}
        />
        <SearchIconWrapper>
          <SearchIcon style={{ color: error ? "#d32f2f" : "#bdbdbd" }} />
        </SearchIconWrapper>
      </Search>
      {error && (
        <Typography 
          variant="caption" 
          sx={{ 
            color: "#d32f2f", 
            mt: '4px',
            ml: '4px',
            fontSize: '10px',
            whiteSpace: 'nowrap',
            display: 'block'
          }}
        >
          Minimum {minChars} characters required
        </Typography>
      )}
    </Box>
  );
};
